<template>
  <div>
    <LoadingBarComponent v-show="subscriptionLoading" loading-text="Loading Device" />
    <v-alert v-if="subscriptionError !== null" text dense type="error">
      {{ subscriptionError }}
    </v-alert>
    <v-scale-transition hide-on-leave>
    <div v-if="subscriptionData.id !== null || subscriptionError !== null">
      <div v-if="subscriptionData.id !== null">
        <div class="d-flex align-center">
          <v-card-title><v-icon class="mr-3">{{getFamilyIcon(subscriptionUnit.transientFamily)}}</v-icon>{{ subscriptionUnit.alias}}</v-card-title>
          <v-spacer/>
          <v-btn icon @click="goBack"><v-icon>mdi-close</v-icon></v-btn>
        </div>
    <v-card>
      <SubscriptionDetails :alias="subscriptionData.transientAlias"/>
    </v-card>
    <v-card class="mt-4">
      <SubscriptionUsersList :subscription-id="subscriptionData.id" :subscription-users="subscriptionUsersData" :error="subscriptionUsersError" :loading="subscriptionUsersLoading"/>
    </v-card>
  </div>
    </div>
    </v-scale-transition>
  </div>
</template>

<script>
import SubscriptionUsersList from '../components/subscription/SubscriptionUsersList'
import LoadingBarComponent from '../components/LoadingBarComponent'
import SubscriptionDetails from '../components/subscription/SubscriptionDetails'
import familyIcon from '../mixins/familyIcon'

export default {
  name: 'Subscription',
  components: {
    SubscriptionUsersList,
    LoadingBarComponent,
    SubscriptionDetails
  },
  mixins: [familyIcon],
  methods: {
    goBack: function () {
      let self = this
      this.$router.push({ name: 'customer', params: { customerId: self.customer.id } })
    }
  },
  created () {
    let self = this
    this.$store.dispatch('subscription/fetchSubscription', self.$route.params.subscriptionId).then(function () {
      self.$store.dispatch('subscription/fetchSubscriptionUsers', self.$route.params.subscriptionId)
    })
  },
  beforeRouteUpdate (to, from, next) {
    let self = this
    if (from.params.subscriptionId !== to.params.subscriptionId) {
      this.$store.dispatch('subscription/resetCurrentSubscription')
      this.$store.dispatch('subscription/fetchSubscription', to.params.subscriptionId).then(function () {
        self.$store.dispatch('subscription/fetchSubscriptionUsers', to.params.subscriptionId)
      })
      next()
    } else {
      next(false)
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('subscription/resetCurrentSubscription')
    next()
  },

  computed: {
    subscriptionData: function () {
      return this.$store.state.subscription.currentSubscription.data
    },
    subscriptionError: function () {
      return this.$store.state.subscription.currentSubscription.error
    },
    subscriptionLoading: function () {
      return this.$store.state.subscription.currentSubscription.data.id === null && this.$store.state.subscription.currentSubscription.error === null
    },
    subscriptionUnit: function () {
      return this.$store.state.subscription.currentSubscriptionUnit
    },
    customer: function () {
      return this.$store.state.customer.currentCustomer.data
    },
    subscriptionUsersData: function () {
      return this.$store.state.subscription.allUsers.data === null ? [] : this.$store.state.subscription.allUsers.data
    },
    subscriptionUsersError: function () {
      return this.$store.state.subscription.allUsers.error
    },
    subscriptionUsersLoading: function () {
      return this.$store.state.subscription.allUsers.data === null && this.$store.state.subscription.allUsers.error === null
    }
  }
}

</script>

<style scoped>

</style>
